import { permissionMaker } from '../../permissionExpression';

const { role } = permissionMaker;

const updateForm = role('ROLE_MANAGER_EDIT');

export const managerEditPermissions = {
    updateForm,
};
